import script from "./HeaderLeftMenuWeb.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderLeftMenuWeb.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderLeftMenuWeb.vue?vue&type=style&index=0&id=2a7ec950&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7ec950"]])

export default __exports__